import { EnumSchema, Executor, FromSchema } from '@40seas/entities/common';
import { RutterValidationStatus } from './rutter-validation.status.enum';
import { Seller } from '@40seas/entities/sellers';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';

export enum RutterValidationEntityType {
    Invoices = 'invoices',
    Buyers = 'buyers',
}

export const RutterValidationSchema = WithBaseEntitySchema(
    z.object({
        status: EnumSchema(RutterValidationStatus),
        cursor: z.string().optional(),
        providerIds: z.array(z.string()).optional(),
        entityType: EnumSchema(RutterValidationEntityType),
    }),
).strict();

export class RutterValidation extends FromSchema(RutterValidationSchema) implements BaseEntity {
    cursor?: string;
    providerIds?: string[];
    entityType: RutterValidationEntityType;
    id: string;
    status: RutterValidationStatus;

    createdAt?: Date | undefined;
    updatedAt?: Date | undefined;
    createdBy?: Executor;
    seller?: string | Seller;
    tenantId: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
